export default __webpack_public_path__ + "static/media/ic-full-test.b9027b00.svg";